import React, { useMemo, useEffect } from "react";
import styles from "../invite-template/index.module.scss";
import { IEmailTemplateFormValues } from "../../../../../common/validations/email-templates.validations";
import cn from "../../../../../Utils/class-names.utils";

interface PreviewContentProps {
  formValues: IEmailTemplateFormValues;
}

const InviteContentPreview = ({ formValues }: PreviewContentProps) => {
  const headerStyle = formValues.backgroundColor 
    ? { backgroundColor: formValues.backgroundColor } 
    : undefined;
  
  const buttonStyle = formValues.buttonColor 
    ? { backgroundColor: formValues.buttonColor } 
    : undefined;

  const textColorStyle = formValues.textColor 
    ? { color: formValues.textColor } 
    : undefined;

  const logoUrl = useMemo(() => {
    if (!formValues.logo) return undefined;
    if (typeof formValues.logo === 'string') return formValues.logo;
    return URL.createObjectURL(formValues.logo);
  }, [formValues.logo]);

  useEffect(() => {
    const url = logoUrl;
    const isFile = formValues.logo instanceof File;
    return () => {
      if (url && isFile) {
        URL.revokeObjectURL(url);
      }
    };
  }, [logoUrl, formValues.logo]);

  return (
    <>
      <header className={styles.header} style={headerStyle}>
        <div className={styles.logoContainer}>
          <img
            className={styles.logo}
            aria-label="HighGround logo icon"
            src={"/images/logo-white.svg"}
          />

          {logoUrl && (
            <img
              className={styles.portlandLogo}
              alt="Custom logo"
              src={logoUrl}
            />
          )}
        </div>

        <div className={styles.content}>
          <div 
            className={styles.title}
            style={textColorStyle}
            dangerouslySetInnerHTML={{ __html: formValues.header }}
          />

          <div 
            className={styles.description}
            style={textColorStyle}
            dangerouslySetInnerHTML={{ __html: formValues.body }}
          />
        </div>
      </header>

      <main className={styles.main}>
        <h2 className={styles.sectionTitle}>
          What&apos;s next?
        </h2>

        <p className={styles.sectionDescription}>
          Click below to accept your invitation. Once activated, you&apos;ll be
          redirected to your dashboard to start exploring.
        </p>

        <button
          type="button"
          className={cn(styles.button, "my-button")}
          style={buttonStyle}
          aria-label="Accept invitation to HighGround workspace"
        >
          <span className={styles.buttonInner}>
            <span className={styles.buttonText}>
              Accept Invitation
            </span>
          </span>
        </button>

        <p className={styles.footerText}>
          If you need any help during setup, just reply — our team&apos;s here
          to walk you through it.
        </p>
      </main>

      <footer
        className={styles.footer}
        aria-label="HighGround footer logo"
      >
        <img src="/images/logo-large.svg" alt="HighGround footer logo" />
      </footer>
    </>
  );
};

export default InviteContentPreview;

